@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.formDescriptionLink {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin: 16px auto;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");

  span {
    cursor: pointer;
    text-decoration: underline;
  }
}

.signUpWrapper {
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
  padding: 40px 24px;
  border-radius: 16px;
  border: 2px solid v.$gray-border-panel-color;
  background: v.$gradient-form-card;
  backdrop-filter: blur(1px);

  @media (min-width: 768px) {
    padding: 40px;
  }
}

.signUpInner {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.signUpTitle {
  margin-bottom: 24px;
  @include t.text(20px, 30px, "bold");
  color: v.$white-color;
}

.signUpForm {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin: 0;
}

.signUpFields {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.signUpRowTwo {
  display: flex;
  gap: 16px;
  width: 100%;
}

.signUpFieldCol {
  width: 100%;
}

.signUpRowFull {
  width: 100%;
}

.countriesSelect {
  padding-right: 40px;
}

.signUpControl {
  border-radius: 6px;
}

.signUpTerms {
  margin: 0;
  @include t.text(14px, 22px, "normal");
  color: v.$gray-light-color;
}

.signUpTermsLink {
  text-decoration: underline;
  cursor: pointer;
}

.formButton {
  gap: 8px;
  cursor: pointer;
  width: 100%;
  display: flex;
  height: 48px;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 8px;
  background: v.$green-color;
  @include t.text(16px, 26px, "semi-bold");
  color: v.$white-color;
  margin: 0;

  &:disabled {
    cursor: not-allowed;
  }
}

.signUpSocial {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.signUpDivider {
  margin: 0;
  width: 100%;
  text-align: center;
  @include t.text(14px, 22px, "normal");
  color: v.$gray-light-color;
}

.signUpFooter {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.signUpFooterLink {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  @include t.text(14px, 22px, "normal");
  color: v.$white-color;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}

.signUpFooterLink:hover {
  text-decoration: underline;
}

.errorMessage {
  text-align: center;
  color: v.$error-color;
  @include t.text(14px, 22px, "normal");
}

.loader {
  width: 30px;
}

.continueWith {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");
}

/* Chinese Brothers */

.signUpWrapperChineseBrothers {
  border: 1px solid v.$chinese-brothers-border-color;
  background: v.$chinese-brothers-card-bg;
}

.formButtonChineseBrothers {
  background: v.$white-color;
  color: v.$navy-dark-color-2;
}